import _DialogTitle from "@mui/material/DialogTitle";
import _Dialog from "@mui/material/Dialog";
import _DialogActions from "@mui/material/DialogActions";
import _DialogContent from "@mui/material/DialogContent";
import _Typography from "@mui/material/Typography";
import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _Close from "@mui/icons-material/Close";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
import { reportTypesTitleKeys } from '../models';
import { RemoveIcon } from './icons';
import { ReportDate, ReportReviews } from './map/report-popup';
export function ReportDialog({
  currentUser,
  reportSourcesMap,
  report,
  onRating,
  onRemove,
  ...props
}) {
  const titleKey = report && reportTypesTitleKeys[report.typeCode];
  const source = report && report.sourceId !== null && reportSourcesMap?.[report.sourceId] || null;
  return /*#__PURE__*/React.createElement(_Dialog, _extends({
    fullWidth: true,
    maxWidth: "md"
  }, props), /*#__PURE__*/React.createElement(StyledDialogTitle, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: titleKey || 'commons.report.default_title'
  }), /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0#", report?.id)), /*#__PURE__*/React.createElement(CloseButtonWrapper, null, /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: () => props.onClose(),
    size: "small"
  }, /*#__PURE__*/React.createElement(_Close, null)))), report?.photos[0] && /*#__PURE__*/React.createElement("img", {
    src: report.photos[0].url
  }), /*#__PURE__*/React.createElement(_DialogContent, null, source && /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.report.source",
    values: {
      source: source.title
    }
  })), report && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Typography, {
    gutterBottom: true,
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/React.createElement(ReportDate, {
    report: report,
    source: source
  })), report.description && /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, report.description))), report && /*#__PURE__*/React.createElement(_DialogActions, null, onRemove && currentUser && report.creatorId === currentUser.id && /*#__PURE__*/React.createElement(_Tooltip, {
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.actions.remove"
    })
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: () => onRemove(report),
    size: "small",
    sx: {
      marginRight: 'auto'
    }
  }, /*#__PURE__*/React.createElement(RemoveIcon, {
    color: "error",
    fontSize: "small"
  }))), onRating && /*#__PURE__*/React.createElement(ReportReviews, {
    currentUser: currentUser,
    onRating: onRating,
    report: report
  })));
}
const StyledDialogTitle = styled(_DialogTitle)`
  && {
    padding-right: 46px;
  }
`;
const CloseButtonWrapper = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;

  button {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;